var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"text","icon":"el-icon-download","loading":_vm.isPreparing},on:{"click":_vm.startDownload}},[_vm._v(" 下载 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }